import React from 'react';
import { Tabs, Tab, Typography, Box, Paper, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import UserOverview from './UserOverview.component';
import UserHoldings from './UserHoldings.component';
import UserTrades from './UserTrades.component';
import UserTokens from './UserTokens.component';
import UserAnalytics from './UserAnalytics.component';
import UserConnectionsTabs from './Connections/UserConnections.component';
import UserConnections from './UserConnections.component';




// --- THEMED TAB PANEL COMPONENT ---

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`tabpanel-${ index }`}
            aria-labelledby={`tab-${ index }`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `tab-${ index }`,
        'aria-controls': `tabpanel-${ index }`,
    };
}

export default function UserTabs({ userId }) {
    const { t } = useTranslation();
    const theme = useTheme();
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const tabLabels = [t('user.overview'), t('user.holdings'), t('user.trades'), t('user.tradedTokens'), t('user.analytics'), t('user.connections')];

    return (
        <Paper sx={{ width: '100%' }}>
            <Tabs
                value={value}
                onChange={handleChange}
                textColor="inherit"
                indicatorColor="primary"
                centered
            >
                {tabLabels.map((label, index) => (
                    <Tab
                        key={index}
                        label={label}
                        {...a11yProps(index)}
                        sx={{
                            color: value === index ? theme.palette.primary.main : theme.palette.text.secondary,
                            '&.Mui-selected': {
                                color: theme.palette.primary.main,
                            },
                            '&:hover': {
                                color: theme.palette.text.primary,
                            }
                        }}
                    />
                ))}
            </Tabs>

            <TabPanel value={value} index={0}>
                <>
                    <UserOverview userId={userId} />
                    <UserConnections userId={userId} />
                </>
            </TabPanel>
            <TabPanel value={value} index={1}>
                <UserHoldings userId={userId} />
            </TabPanel>
            <TabPanel value={value} index={2}>
                <UserTrades userId={userId} />
            </TabPanel>
            <TabPanel value={value} index={3}>
                <UserTokens userId={userId} />
            </TabPanel>
            <TabPanel value={value} index={4}>
                <UserAnalytics userId={userId} />
            </TabPanel>
            <TabPanel value={value} index={5}>
                <UserConnectionsTabs userId={userId} />
            </TabPanel>
        </Paper>
    );
}
